module.exports = __webpack_public_path__ + "static/media/LocationIcon.23add9fd.svg";